import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import { FootnotesPipe, RouterLinkDirective, TrackingDirective } from '@hyundai/ng-common-lib';
import { M010C020IconLinkComponent } from '../../../010-buttons-and-links/m010-c020-icon-link/m010-c020-icon-link.component';
import type { M060C010VehicleShowroomButtonsData } from './m060-c010-vehicle-showroom-buttons.interface';

@Component({
    selector: 'ui-m060-c010-vehicle-showroom-buttons',
    standalone: true,
    templateUrl: './m060-c010-vehicle-showroom-buttons.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [M010C020IconLinkComponent, RouterLinkDirective, FootnotesPipe, TrackingDirective],
})
export class M060C010VehicleShowroomButtonsComponent {
    data = input.required<M060C010VehicleShowroomButtonsData[]>();

    primaryButton = input.required<string>();
    primaryButtonText = input.required<string>();
    envkv = input<string>();
}
